import {
    NOTIFICATION_DISPLAYED,
    NOTIFICATION_HIDDEN,
    NOTIFICATION_DISPLAY_REQUEST,
    NOTIFICATION_HIDE_REQUEST,
} from '../constants';

export const notifRequested = notification => {
    return {
        type: NOTIFICATION_DISPLAY_REQUEST,
        payload: {
            ...notification,
            id: new Date().getUTCDate(),
        },
    };
};

export const hideNotifRequested = id => {
    return {
        type: NOTIFICATION_HIDE_REQUEST,
        payload: {
            id,
        },
    };
};

export const notificationDisplayed = notification => {
    return {
        type: NOTIFICATION_DISPLAYED,
        payload: {
            ...notification,
        },
    };
};

export const notificationHidden = notification => {
    return {
        type: NOTIFICATION_HIDDEN,
        payload: {
            ...notification,
        },
    };
};



// WEBPACK FOOTER //
// ./src/middleware/notifications/actions/index.js